import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { SplitButton } from 'primereact/splitbutton';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';


//import x from './uploads/file-1557488649040.pdf';
//import y from './uploads/file-1560414054518.pdf';
//import z from './uploads/file-1561622017174.doc';

var haberler=[];
const ButtonDemo = (props) => {
  

    const [value,setValue] = useState('');
    const [expandedRows, setExpandedRows] = useState(null);


    const [pdfName,setPdfName] = useState();



    useEffect(() => {
        setValue(props.value.yil);
        setPdfName("");
        haberler=[];
        if(props.value!=[]){
            for(var i=0;i<props.data.duyurular.length;i++){
                if(props.data.duyurular[i].tarih.slice(6,10).toString()==props.value.yil.toString()){
                    haberler.push(props.data.duyurular[i]);
                }else if(props.value.yil=='Tümü'){
                    haberler.push(props.data.duyurular[i]);
                }
            }
        }
        
        //setHaberler(props.data.duyurular);
        //console.log(props.value,props.data.duyurular);
    }, [value]);


    const rowExpansionTemplate = (data) => {
        setPdfName(data.dosya);
        //console.log(data.dosya);
        //console.log(x.substr(14,18),"+++++",data.dosya.substr(9,50));
        /*if(x.substr(14,18)+'.pdf'==data.dosya.substr(9,50)){
            setPdfName(x);
        }else if(y.substr(14,18)+'.pdf'==data.dosya.substr(9,50)){
            setPdfName(y);
        }
        else{
            setPdfName("");
        }*/

        return (
            <div >
                {data.dosya!="" ?
                    

                    <div >
                        <iframe src={require('.'+data.dosya)} type="application/pdf" height="600" width="100%"></iframe>
                    </div>
                    
                    :
                    <div>
                         <h5>{data.icerik.replace(/<[^>]+>/g, '').replace(/&nbsp;/g,'')}</h5>
                    </div>
                }

            </div>
        );

        
    }

    return (
        <div className="grid">
            <div className="col-12 md:col-16">
                <div className='card'>
                    {value=='Tümü' ? <h5 style={{marginLeft:350}}>{value.substr(0,3)} Haberler ve Duyurular</h5>
                                   :
                                     <h5 style={{marginLeft:350}}>{value} Dönemine Ait Haberler ve Duyurular</h5>}
                    
                </div>
                
                <div className="card">
                   

                    <DataTable value={haberler} expandedRows={expandedRows} onRowToggle={(e) => {setExpandedRows(e.data);}} responsiveLayout="scroll"
                        rowExpansionTemplate={rowExpansionTemplate}  dataKey="tarih" >
                        <Column expander style={{ width: '3em' }} />
                        <Column field="tarih" header="Tarih" sortable />
                        <Column field="baslik" header="Başlık" sortable />
                    </DataTable>
                                    
                </div>
                        
            </div>
        </div>
    )
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};


export default React.memo(ButtonDemo, comparisonFn);